import type { ApiEnvelope } from "@thesleepybot/shared";

const configuredBaseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, "") ?? "";
const baseUrl = import.meta.env.PROD ? "" : configuredBaseUrl;

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${baseUrl}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-Sleepy-CSRF": "1",
      ...init?.headers,
    },
  });

  const payload = (await response.json().catch(() => ({
    ok: false,
    error: "The server returned an unreadable response.",
  }))) as ApiEnvelope<T>;

  if (!response.ok || !payload.ok || payload.data === undefined) {
    throw new ApiError(payload.error ?? "Request failed.", response.status);
  }

  return payload.data;
}

export async function apiUpload<T>(path: string, file: File): Promise<T> {
  const response = await fetch(`${baseUrl}${path}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": file.type,
      "X-Sleepy-CSRF": "1",
    },
    body: file,
  });

  const payload = (await response.json().catch(() => ({
    ok: false,
    error: "The server returned an unreadable response.",
  }))) as ApiEnvelope<T>;

  if (!response.ok || !payload.ok || payload.data === undefined) {
    throw new ApiError(payload.error ?? "Upload failed.", response.status);
  }

  return payload.data;
}

export function apiBaseUrl(): string {
  return baseUrl;
}
